import { useState } from "react";
import { X, Loader2 } from "lucide-react";
import useResetStation from "../../hooks/useResetStation";

export default function FullResetDialog({ onClose }) {
  const { resetStation, isLoading, error: hookError } = useResetStation();

  const [stationId, setStationId] = useState("");
  const [error, setError] = useState("");

  const handleSubmit = async () => {
    setError("");

    if (!stationId.trim()) {
      setError("Please enter Station ID to confirm full reset");
      return;
    }

    const res = await resetStation({ stationId });

    if (res.success) {
      onClose();
    } else {
      setError(res.error || "Failed to perform full reset");
    }
  };

  return (
    <div className="fixed inset-0 bg-black/50 backdrop-blur-sm flex items-center justify-center p-4 z-50">
      <div className="bg-white w-full max-w-md rounded-xl shadow-xl border border-gray-200">

        {/* Header */}
        <div className="flex items-center justify-between px-5 py-4 border-b">
          <h2 className="text-lg font-semibold text-gray-900">Full Reset</h2>
          <button
            onClick={onClose}
            className="p-2 rounded-lg hover:bg-gray-100 transition"
          >
            <X size={18} className="text-gray-700" />
          </button>
        </div>

        {/* Body */}
        <div className="px-5 py-5 space-y-4">

          {/* Warning box */}
          <div className="border border-red-300 bg-red-50 rounded-lg p-3 text-sm text-red-700">
            ⚠️ This will completely reset the station.  
            All configuration & stored data will be deleted.
          </div>

          {/* Station ID input */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Station ID
            </label>
            <input
              value={stationId}
              onChange={(e) => setStationId(e.target.value)}
              className="w-full px-3 py-2 border rounded-lg bg-gray-50 
                         focus:outline-none focus:ring-2 focus:ring-black/10"
            />
          </div>

          {(error || hookError) && (
            <p className="text-sm text-red-600">{error || hookError}</p>
          )}
        </div>

        {/* Footer */}
        <div className="px-5 py-4 border-t flex justify-end gap-3">
          <button
            onClick={onClose}
            className="px-4 py-2 rounded-lg border border-gray-300 text-gray-700 hover:bg-gray-100 transition"
          >
            Cancel
          </button>

          <button
            disabled={isLoading}
            onClick={handleSubmit}
            className="px-4 py-2 rounded-lg bg-red-600 text-white flex items-center gap-2 
                       hover:bg-red-700 transition disabled:opacity-50"
          >
            {isLoading && <Loader2 size={16} className="animate-spin" />}
            Full Reset
          </button>
        </div>

      </div>
    </div>
  );
}
